/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Language } from '../../models/language';
import { UpdateLanguageDto } from '../../models/update-language-dto';

export interface LanguagesControllerUpdate$Params {

/**
 * The language id
 */
  id: string;
  
    /**
     * The language data to update the language
     */
    body: UpdateLanguageDto
}

export function languagesControllerUpdate(http: HttpClient, rootUrl: string, params: LanguagesControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Language>> {
  const rb = new RequestBuilder(rootUrl, languagesControllerUpdate.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Language>;
    })
  );
}

languagesControllerUpdate.PATH = '/languages/{id}';
